import pathify from "vuex-pathify";

pathify.options.mapping = "simple";
pathify.options.strict = true;

export default pathify;
